import * as styles from "./QuoteBlock.css"

type QuoteBlockProps = {
	children: React.ReactNode
	viewTransitions?: "default" | "none"
}
export default function QuoteBlock({
	children,
	viewTransitions,
}: QuoteBlockProps) {
	return (
		<div className={styles.quoteBlock({ viewTransitions })}>{children}</div>
	)
}
